import axios, { AxiosResponse } from 'axios';
import { LoggedUser } from '../types/Usuario/LoggedUser';
import { InfoGestor } from '../types/Usuario/InfoGestor';
import apiInterceptor from '../utils/axios';
import { User, UserAcad } from '../types/Usuario/User';
import { PaginateObj } from '../types/Paginate/PaginateObjt';
import { GenericResponse } from '../types/Response/GenericResponse';
import { EditRoleDTO } from '../types/Usuario/EditRoleDTO';

const SERV_BACK: string = process.env.REACT_APP_API_ESPOL_ADS || '';
const APIACCOUNT = 'api/Accounts/';

export default class AccountService {

    static async GetAccountsPaginate(): Promise<PaginateObj<User>> {
        const response1: AxiosResponse<PaginateObj<User>> = await apiInterceptor.get(`${SERV_BACK}${APIACCOUNT}users/page`,
            {
                headers:{
                    "Content-type" : "application/json",
                },
            }
        );
        return response1.data;
    }

    static async GetAccountsPaginateByName(name: string): Promise<PaginateObj<User>> {
        const response1: AxiosResponse<PaginateObj<User>> = await apiInterceptor.get(`${SERV_BACK}${APIACCOUNT}users/page/${name}`,
            {
                headers:{
                    "Content-type" : "application/json",
                },
            }
        );
        return response1.data;
    }

    static async GetUsuarioByName(name: string): Promise<Array<UserAcad>> {
        const response1: AxiosResponse<Array<UserAcad>> = await apiInterceptor.get(`${SERV_BACK}${APIACCOUNT}user/searchAcadByLastName/${name}`,
            {
                headers:{
                    "Content-type" : "application/json",
                },
            }
        );
        return response1.data;
    }

    static async GetPageUserByNumber(link: string, pageNum: number): Promise<PaginateObj<User>> {
        const baseUrl = link.substring(0, link.indexOf('?'));
        const params = new URLSearchParams({
            pageNumber: pageNum.toString(),
            pageSize: "8", // Tamaño fijo por página
        });
        const response1: AxiosResponse<PaginateObj<User>> = await apiInterceptor.get(`${baseUrl}?${params.toString()}`);
        return response1.data;
    }

    static async GetIdUserByRol(rol: string): Promise<Array<string>> {
        const response1: AxiosResponse<Array<string>> = await apiInterceptor.get(`${SERV_BACK}${APIACCOUNT}Claims-Roles/${rol}`,
            {
                headers:{
                    "Content-type" : "application/json",
                },
            }
        );
        return response1.data;
    }

    static async LoginEspolAds(username: string): Promise<LoggedUser> {
        const body = JSON.stringify({ username: username });
        const response1: AxiosResponse<LoggedUser> = await axios.post(`${SERV_BACK}${APIACCOUNT}login`,
            body,
            {
                headers:{
                    "Content-type" : "application/json",
                },
            }
        );
        return response1.data;
    }

    static async InfoGestor(): Promise<InfoGestor> {
        const response1: AxiosResponse<InfoGestor> = await apiInterceptor.get(`${SERV_BACK}${APIACCOUNT}infogestor`,
            {
                headers:{
                    "Content-type" : "application/json",
                },
            }
        );
        return response1.data;
    }

    static async AsignarRol(role: EditRoleDTO): Promise<GenericResponse> {
        try {
            const response: AxiosResponse<any> = await apiInterceptor.post(`${SERV_BACK}${APIACCOUNT}assignRole/`,
                role,
                {
                    headers: {
                        "Content-type": "application/json",
                    },
                }
            );
            if (response.status === 204) {
                console.log('Respuesta exitosa');
                return {
                  status: response.status,
                  message: 'Operación completada con éxito',
                };
              } else {
                console.error('Respuesta no exitosa:', response.status);
                return {
                  status: response.status,
                  message: `Error: Código de estado ${response.status}`,
                };
              }
        } catch (error) {
            console.error('Error al realizar la solicitud:', error);

            return {
                status: 500,
                message: 'Error al realizar la solicitud',
            };
        }
    }

    static async RemoverRol(role: EditRoleDTO): Promise<GenericResponse> {
        try {
            const response: AxiosResponse<any> = await apiInterceptor.post(`${SERV_BACK}${APIACCOUNT}removeRole/`,
                role,
                {
                    headers: {
                        "Content-type": "application/json",
                    },
                }
            );
            if (response.status === 204) {
                console.log('Respuesta exitosa');
                return {
                  status: response.status,
                  message: 'Operación completada con éxito',
                };
              } else {
                console.error('Respuesta no exitosa:', response.status);
                return {
                  status: response.status,
                  message: `Error: Código de estado ${response.status}`,
                };
              }
        } catch (error) {
            console.error('Error al realizar la solicitud:', error);

            return {
                status: 500,
                message: 'Error al realizar la solicitud',
            };
        }
    }

}